import React, { useEffect, useState, useRef } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import "./App.css";
import { useBeforeunload } from "react-beforeunload";
// import Crunker from "crunker";
import beep from "./beep.mp3";

const STATS_KEY = "stats";
// const BEEP_INTERVAL = 600;

// async function makeBeepSound() {
//   let crunker = new Crunker();
//   const buffers = await crunker.fetchAudio(sound);
//   const merged = await crunker.padAudio(buffers[0], 0, BEEP_INTERVAL);
//   const output = await crunker.export(merged, "audio/mp3");
//   return URL.createObjectURL(output.blob);
// }

function formatTimeDelta(timeDelta, needSeconds = true) {
  const hours = Math.floor(timeDelta / 1000 / 60 / 60)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((timeDelta / 1000 / 60) % 60)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor((timeDelta / 1000) % 60)
    .toString()
    .padStart(2, "0");
  if (!needSeconds) {
    return `${hours}:${minutes}`;
  }
  return `${hours}:${minutes}:${seconds}`;
}

function Timer({ startTime, currentTime }) {
  if (!startTime) {
    return <div className="text-danger">Таймер остановлен</div>;
  }
  const timeDiff = currentTime - startTime;
  return <div>{formatTimeDelta(timeDiff)}</div>;
}

function Stats({ stats, period, title, startTime, currentTime }) {
  if (!stats) {
    return null;
  }
  const [periodStart, periodEnd] = period;
  const statsInPeriod = {};
  for (const [key, value] of Object.entries(stats)) {
    const date = new Date(parseInt(key));
    if (date >= periodStart && date <= periodEnd) {
      statsInPeriod[key] = value;
    }
  }
  const total = Object.values(statsInPeriod).reduce((a, b) => a + b, 0);
  if (startTime) {
    return (
      <div>
        {title}: {formatTimeDelta(total + (currentTime - startTime), false)}
      </div>
    );
  }
  return (
    <div>
      {title}: {formatTimeDelta(total, false)}
    </div>
  );
}

function getTodayPeriod() {
  const today = new Date();
  const start = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const end = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 1
  );
  return [start, end];
}

function getThisWeekPeriod() {
  const today = new Date();
  const start = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - ((today.getDay() + 6) % 7)
  );
  const end = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 7 - ((today.getDay() + 6) % 7)
  );
  return [start, end];
}

function getLast7DaysPeriod() {
  const today = new Date();
  const start = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 6
  );
  const end = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 1
  );
  return [start, end];
}

function getThisMonthPeriod() {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const end = new Date(today.getFullYear(), today.getMonth() + 1, 1);
  return [start, end];
}

function getThisYearPeriod() {
  const today = new Date();
  const start = new Date(today.getFullYear(), 0, 1);
  const end = new Date(today.getFullYear() + 1, 0, 1);
  return [start, end];
}

function App() {
  function startTimer() {
    myAudio.current.currentTime = 2;
    myAudio.current.play();
    setStartTime(new Date());
    setTickInterval(
      setInterval(() => {
        setCurrentTime(new Date());
      })
    );

    // Раз в 10 минут вызывавется эта пищалка. Можно поменять закодированный WAV файл
    // function beep() {
    //   myAudio.current.play();
    // }
    // Запустили следующий цикл пищалки
    // setAlarmInterval(setInterval(beep, window.debugBeepInterval || 600000));
  }
  // Остановка таймера
  function stopTimer() {
    myAudio.current.pause();
    // Если не был запущен, то нечего и останавливать
    // Просто эту функцию вызывают не только по кнопке,
    // но и по закрытию окна
    if (!startTime) {
      return;
    }
    setStartTime(null);
    // !!!Не понял сути!!!
    let updatedStats = { ...stats };
    updatedStats[startTime.getTime()] = currentTime - startTime;
    // Сохранили текущую статистику
    saveStats(updatedStats);
    // Остановили таймер
    clearInterval(tickInterval);
    // И десятиминутную пищалку тоже оствновили. Ибо нефиг
    // clearInterval(alarmInterval);
  }

  // Подгружаем статистику из внешнего хранилища
  function loadStats() {
    let loadedStats = localStorage.getItem(STATS_KEY);
    if (!loadedStats) {
      return {};
    }
    return JSON.parse(loadedStats);
  }
  // Сохраняем статистику во внешнем хранилище
  function saveStats(stats) {
    localStorage.setItem(STATS_KEY, JSON.stringify(stats));
    setStats(stats);
  }
  // Все свойства кнопки "Старт"
  const startButton = (
    <Button variant="success" size="lg" onClick={startTimer}>
      Старт
    </Button>
  );
  // Все свойства кнопки "Стоп"
  const stopButton = (
    <Button variant="danger" size="lg" onClick={stopTimer}>
      Стоп
    </Button>
  );
  const exportStats = () => {
    const statsString = JSON.stringify(stats);
    const blob = new Blob([statsString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "stats.json");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const openImportPrompt = () => {
    inputFile.current.click();
  };
  const importStats = () => {
    const file = inputFile.current.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const loadedStats = JSON.parse(e.target.result);
      if (
        window.confirm(
          "Вы уверены, что хотите импортировать статистику? Все текущие данные будут утеряны!"
        )
      ) {
        saveStats(loadedStats);
      }
    };
    reader.readAsText(file);
  };
  const makeReport = () => {
    const report = Object.keys(stats)
      .filter((key) => {
        const date = new Date(Number(key));
        const today = new Date();
        return (
          date >=
          new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30)
        );
      })
      .map((key) => {
        const date = new Date(Number(key));
        const hours = Math.floor(stats[key] / 3600000);
        const minutes = Math.round((stats[key] % 3600000) / 60000);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()} - ${hours} часов ${minutes} минут`;
      })
      .join("\n");
    navigator.share({
      title: "Отчёт",
      text: report,
    });
  };

  const inputFile = useRef(null);
  const myAudio = useRef();
  const [startTime, setStartTime] = useState(null);
  const [currentTime, setCurrentTime] = useState(null);
  const [tickInterval, setTickInterval] = useState(null);
  // const [alarmInterval, setAlarmInterval] = useState(null);
  const [stats, setStats] = useState(null);
  useEffect(() => {
    (async () => {
      // const beepSound = await makeBeepSound();
      myAudio.current.src = beep;
    })();
    setStats(loadStats());
  }, []);

  useBeforeunload(stopTimer);
  return (
    <div className="container d-flex flex-column justify-content-between vh-100">
      <div className="d-flex flex-column align-items-center justify-content-center">
        <Timer startTime={startTime} currentTime={currentTime} />
        {startTime ? stopButton : startButton}

        <Stats
          period={getTodayPeriod()}
          stats={stats}
          title="Сегодня"
          startTime={startTime}
          currentTime={currentTime}
        />
        <Stats
          period={getLast7DaysPeriod()}
          stats={stats}
          title="Последние 7 дней"
          startTime={startTime}
          currentTime={currentTime}
        />
        <Stats
          period={getThisWeekPeriod()}
          stats={stats}
          title="Неделя"
          startTime={startTime}
          currentTime={currentTime}
        />
        <Stats
          period={getThisMonthPeriod()}
          stats={stats}
          title="Месяц"
          startTime={startTime}
          currentTime={currentTime}
        />
        <Stats
          period={getThisYearPeriod()}
          stats={stats}
          title="Год"
          startTime={startTime}
          currentTime={currentTime}
        />
      </div>
      <div>
        <ButtonGroup className="w-100">
          <Button variant="secondary" onClick={exportStats}>
            Экспортировать в файл
          </Button>
          <Button variant="secondary" onClick={openImportPrompt}>
            Импортировать из файла
          </Button>
          <Button variant="secondary" onClick={makeReport}>
            Создать отчёт
          </Button>
        </ButtonGroup>
        <input
          type="file"
          ref={inputFile}
          style={{ display: "none" }}
          onChange={importStats}
        />
      </div>
      <audio loop ref={myAudio} />
    </div>
  );
}

export default App;
